import React from 'react';
import AuthContext from 'contexts/AuthContext';
import { createRole } from 'components/helpers/Role';

export default Component => props => {
  return (
    <AuthContext.Consumer>
      {contextProps => {
        const role = createRole(contextProps.currentUser);
        const { processing: loginProcessing } = contextProps;
        return (
          <Component role={role} loginProcessing={loginProcessing} {...props} />
        );
      }}
    </AuthContext.Consumer>
  );
};



// WEBPACK FOOTER //
// ./src/decorators/withUserRole.jsx